package mapsearch.buildings

import model.Building
import model.Floor


/**
 * Convenience Functions for Buildings
 */
fun Map<String, Building>.getBuilding(floorId: String): Building? {
    return values.firstOrNull { building ->
        building.getFloor(floorId) != null
    }
}

fun Map<String, Building>.getBuildingAndFloor(floorId: String): Pair<Building, Floor>? {
    return values.firstNotNullOfOrNull { building ->
        building.getFloor(floorId)?.let { floor ->
            building to floor
        }
    }
}

fun Map<String, Building>.getBuildingAndFloorLevel(floorId: String): Pair<Building, Double>? {
    return values.firstNotNullOfOrNull { building ->
        building.getFloorLevel(floorId)?.let { level ->
            building to level
        }
    }
}

fun Building.getFloor(floorId: String): Floor? {
    return floorData?.values?.flatten()?.firstOrNull { it.floor.id == floorId }
}

fun MutableMap<Double, List<Floor>>?.getFloorLevel(floorId: String?): Double? {
    return this?.entries?.firstOrNull { (level, floors) ->
        floors.map { floor -> floor.floor.id }.contains(floorId)
    }?.key
}

fun Building.getFloorLevel(floorId: String?): Double? {
    return floorData.getFloorLevel(floorId)
}

val Building.getActiveFloors
    get() = floorData?.get(activeFloorLevel)
        ?: floorData?.get(defaultFloorLevel)
        ?: floorData?.firstNotNullOfOrNull { it.value }

val List<Building>.getActiveFloorIds
    get() = mapNotNull { building -> building.getActiveFloors }
        .flatMap { floors -> floors.map { floor -> floor.floor.id } }
